import { AddressProps } from './address.type'
import { CatalogProductProps } from './catalog-product.type'
import {
  FinanceProfilePaymentFormsEnum,
  FinanceProfileTransactionPaymentMethodsEnum,
} from './finance-profile.type'
import { ProfileProps } from './profiles.type'
import { QuotationProps } from './quotation.type'
import { UserProps } from './user.type'

export enum QuotationRequestItemCategoryEnum {
  'pp',
  'pe',
  'pc',
  'abs',
  'eva',
  'ps',
  'tpe',
  'pet',
  'pvc',
  'pa',
}

export interface QuotationRequestItemProductProps {
  title: string
  density: number
  fluidity: number
  category: string
  size: string
  quantityPerPackage: string
  itemDataSheetPath: string
  smartCatalogProductUuid?: string
}

export interface QuotationRequestItemProps {
  uuid: string
  product: Partial<QuotationRequestItemProductProps>
  catalogProductUuid?: string
  catalogProduct?: CatalogProductProps
  quantity: number
  targetPrice: number
  purchaseFrequency: string
  observation: string
  isSimilarAccepted: boolean
  createdAt: string
  complementFile?: string
  complementFilePath?: string
}

export enum QuotationRequestStatusEnum {
  'pending' = 'pending',
  'processed' = 'processed',
  'completed' = 'completed',
  'expired' = 'expired',
  'invalid' = 'invalid',
  'disqualified' = 'disqualified',
  'qualified' = 'qualified',
  'approved_for_quotation' = 'approved_for_quotation',
  'created' = 'created',
  'draft' = 'draft',
}

export enum QuotationRequestOriginEnum {
  'quotation_request' = 'quotation_request',
  'catalog' = 'catalog',
  'backoffice_quotation_request' = 'backoffice_quotation_request',
  'open_quotation_request' = 'open_quotation_request',
  'open_catalog' = 'open_catalog',
  'product_match' = 'product_match',
  'trade_show' = 'trade_show',
  'assistant_guest' = 'assistant_guest',
  'assistant_whatsapp_inbound' = 'assistant_whatsapp_inbound',
  'assistant_whatsapp_outbound' = 'assistant_whatsapp_outbound',
  'assistant_web_authenticated' = 'assistant_web_authenticated',
}

export interface QuotationRequestRefusedByProps {
  id: string
  name: string
  email: string
  phone: string
  isActive: string
  allowEmail: string
  allowWhatsapp: string
}

export enum QuotationRequestDeliveryEnum {
  'pick_up' = 'pick_up',
  'receive_at_address' = 'receive_at_address',
}

export interface QuotationRequestAiQualificationDataProps {
  externalConversationUuid: string
  finalScoring: number
  qualifiedAt: string
  recommendation: string
  isQualified: boolean
  moscowClassification: 'must' | 'should' | 'could' | 'wont' | 'unknown'
}

export interface QuotationRequestProps {
  uuid: string
  file: string
  filePath: string
  reference: string
  status: keyof typeof QuotationRequestStatusEnum
  address: Partial<AddressProps>
  addressUuid: string
  items: Partial<QuotationRequestItemProps>[] | QuotationRequestItemProps[]
  origin: keyof typeof QuotationRequestOriginEnum
  quotations?: QuotationProps[]
  createdAt: string
  updatedAt: string
  buyerProfile: ProfileProps
  buyerProfileUuid: string
  creatorUser: {
    name: string
    email: string
  }
  categories?: string[]
  refusedReason?: string
  refusedBy?: QuotationRequestRefusedByProps
  trafficSource?: string
  isSample?: boolean
  deliveryOption?: keyof typeof QuotationRequestDeliveryEnum
  paymentFormOption?: keyof typeof FinanceProfilePaymentFormsEnum
  paymentMethodOption?: keyof typeof FinanceProfileTransactionPaymentMethodsEnum
  keyAccountManager?: UserProps
  rawInformation?: string
  aiQualificationData?: QuotationRequestAiQualificationDataProps
}

export interface QuotationRequestListWithPagesProps {
  count: number
  next?: string
  previous?: string
  results?: QuotationRequestProps[]
}

export enum QuotationRequestSplitEnum {
  keep_in_current = 'keep_in_current',
  create_for_each = 'create_for_each',
  create_with_selected = 'create_with_selected',
}

export interface QuotationRequestClassificationProps {
  pendingAcquisition: string
  pendingSupply: string
  invalid: string
  expired: string
  total: string
}

export interface QuotationRequestSlasProps {
  approvedForQuotationToProcessedConversion: number
  approvedForQuotationToProcessedConversionVariation: number
  approvedForQuotationToProcessedSla: number
  createdToProcessedSla: number
  createdToProcessedSlaVariation: number
  approvedForQuotationToProcessedSlaVariation: number
  newUsers: number
  newUsersVariation: number
  pendingToApprovedForQuotationConversion: number
  pendingToApprovedForQuotationConversionVariation: number
  pendingToApprovedForQuotationSla: number
  pendingToApprovedForQuotationSlaVariation: number
  qualifiedToProcessedConversion: number
  qualifiedToProcessedConversionVariation: number
  createdToAutomaticProcessedSla: number
  createdToAutomaticProcessedSlaVariation: number
  createdToAutomaticProcessedConversion: number
  createdToAutomaticProcessedConversionVariation: number
  qualifiedToProcessedSla: number
  qualifiedToProcessedSlaVariation: number
}
